<div
  [id]="id"
  class="toggle-container"
  [class.disabled]="disabled"
  [class.large]="size === ToggleSize.large"
  [class.medium]="size === ToggleSize.medium"
  [class.small]="size === ToggleSize.small"
>
    <button
      id="tabs-icon-buttons-check"
      class="toggle-option check"
      (click)="onToggle(Status.VALIDATED)"
      [class.selected]="isSelected(Status.VALIDATED)"
      [disabled]="disabled || isSelected(Status.VALIDATED)"
      data-testid="toggle-buttons-check"
      [style.background-color]="
      isSelected(Status.VALIDATED)
          ? Color.primary300
          : null
      "
    >
        <app-icon
          class="em"
          [size]="
            size === ToggleSize.large
              ? IconSize['medium-small']
              : IconSize.small
          "
          [iconStyle]="Style.bold"
          [color]="
            isSelected(Status.VALIDATED)
              ? Color.white : Color.grey500
          "
          phosphorClass="ph-check ph-bold"
        ></app-icon>
    </button>

    <div
    class="toggle-option middle"
    (click)="onToggle(Status.GENERATED)"

      [style.background-color]="
      isSelected(Status.GENERATED)
          ? Color.grey500
          : null
      "
    >

    </div>

    <button
      id="tabs-icon-buttons-refused"
      data-testid="toggle-buttons-refuse"
      class="toggle-option refused"
      [ngClass]="isSelected(Status.REFUSED) ? 
        'selected' : ''"
      (click)="onToggle(Status.REFUSED)"
      [class.selected]="isSelected(Status.REFUSED)"
      [disabled]="disabled || isSelected(Status.REFUSED)"
      [style.background-color]="
      isSelected(Status.REFUSED)
          ? Color.danger300
          : null
      "
      
    >
        <app-icon
          class="em"
          [size]="
            size === ToggleSize.large
              ? IconSize['medium-small']
              : IconSize.small
          "
          [iconStyle]="Style.bold"
          [color]="
            isSelected(Status.REFUSED)
              ? Color.white : Color.grey500
          "
          phosphorClass="ph-x ph-bold"
        ></app-icon>
    </button>



</div>
